import { Border } from 'themes/interfaces';

export default {
  factor: 4,
  radius: 2,
  square: 1,
  circle: 30
} as Border;
